export default class AbstractDocumentDataEmployeeRepresentation {
  _id;

  _clientId;

  _name;

  _language;

  _employeeName;

  _employeeSurname;

  _employeeNif;

  _lastModification;

  setId(id) {
    this._id = id;
  }

  setClientId(clientId) {
    this._clientId = clientId;
  }

  setName(name) {
    this._name = name;
  }

  setLanguage(language) {
    this._language = language;
  }

  setEmployeeName(employeeName) {
    this._employeeName = employeeName;
  }

  setEmployeeSurname(employeeSurname) {
    this._employeeSurname = employeeSurname;
  }

  setEmployeeNif(employeeNif) {
    this._employeeNif = employeeNif;
  }

  setLastModification(lastModification) {
    this._lastModification = lastModification;
  }
}
